
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    mobileReports() {
      const selected = [0, 4]

      return this.blok.reports.filter((_, i) => selected.includes(i))
    },
  },
}
